const devMsg =
  'There is an error in your form. Please contact the SCA digital team.';

export default function formioValidation({ name }) {
  if (name.message === 'The Name must be unique per Project.') {
    return 'A form with the same name already exists. Please choose another name';
  }
  return devMsg;
}
